const organizationQueryKeys = {
    all: ['organization'] as const,
    detail: () => [...organizationQueryKeys.all, 'detail'] as const,
};

export default organizationQueryKeys;